import { useMemo } from 'react';
// @ts-expect-error untyped import
import UISortableList from 'ui-addon-draggable/list/UISortableList';
// @ts-expect-error untyped import
import UIDragListItem from 'ui-addon-draggable/list/UIDragListItem';
import debounce from 'react-utils/debounce';
import { jsx as _jsx } from "react/jsx-runtime";
const ON_ORDER_CHANGE_DEBOUNCE_MILLIS = 50;
export const DraggableList = ({
  dragGroupId,
  orderedItems,
  onOrderChange
}) => {
  const orderedIds = useMemo(() => orderedItems.map(({
    id
  }) => id), [orderedItems]);
  const renderedContents = useMemo(() => orderedItems.map(item => /*#__PURE__*/_jsx(UIDragListItem, {
    dragId: item.id,
    ariaLabel: item.ariaLabel,
    children: item.children
  }, item.id)), [orderedItems]);
  const handleOrderChange = useMemo(() => debounce(onOrderChange, ON_ORDER_CHANGE_DEBOUNCE_MILLIS), [onOrderChange]);
  return /*#__PURE__*/_jsx(UISortableList, {
    animate: false,
    disableDropOnHover: true,
    dragGroup: dragGroupId,
    order: orderedIds,
    onOrderChange: handleOrderChange,
    children: renderedContents
  });
};